/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface TuteurLieuFormationSearchDto
 */
export interface TuteurLieuFormationSearchDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationSearchDto
     */
    idtuteur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TuteurLieuFormationSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TuteurLieuFormationSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TuteurLieuFormationSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TuteurLieuFormationSearchDto interface.
 */
export function instanceOfTuteurLieuFormationSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurLieuFormationSearchDtoFromJSON(json: any): TuteurLieuFormationSearchDto {
    return TuteurLieuFormationSearchDtoFromJSONTyped(json, false);
}

export function TuteurLieuFormationSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurLieuFormationSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TuteurLieuFormationSearchDtoToJSON(value?: TuteurLieuFormationSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteur': value.idtuteur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

